//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

  data: function () {
    return {
      dateTimes: [],
      page: 1,

      selectedDate: null,

      isLoading: false,
      isAvaiblePrev: true,
      isAvaibleNext: true,

      swiperDate: {
        loop: false,
        spaceBetween: 8,
        slidesPerView: 3,
        breakpoints: {
          990: {
            slidesPerView: 4,
          },
        },
        navigation: {
          prevEl: '.date-and-time-api__button-pagination.--prev',
          nextEl: '.date-and-time-api__button-pagination.--next'
        }
      },
      swiperTime: {
        spaceBetween: 8,
        slidesPerView: 3,
        breakpoints: {
          990: {
            slidesPerView: 5,
          },
        },
        loop: false,
        navigation: {
          prevEl: '.swiper-button-prev--time',
          nextEl: '.swiper-button-next--time'
        }
      },
    }
  },

  props: {
    formInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    initData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    selectedSpecialistId: {}
  },

  computed: {

    isDisabledDateNext: function () {
      return !this.isAvaibleNext
    },

    selectedDateTimes: function () {
      const items = this.dateTimes.find((t) => Boolean(t.date === this.selectedDate))?.items || [];
      const selectedDay = this.dateTimes.find((t) => Boolean(t.date === this.selectedDate)).dateMoment;

      return items.map((_item) => {
        const startTime = (_item?.begin || '').split(':').splice(0,2).join(':');
        const endTime = (_item?.end || '').split(':').splice(0,2).join(':');

        return {
          ..._item,
          value: [selectedDay, startTime, endTime].join('-')
        }
      });
    },

  },

  watch: {
    selectedSpecialistId: async function () {
      await this.resetDateTimes();
    },
  },

  mounted: async function () {
    await this.getDateTimes();
  },

  methods: {

    resetDateTimes: async function () {
      this.page = 1;
      this.dateTimes = [];
      this.isLoading = false;
      this.selectedDate = null;
      await this.getDateTimes();
    },

    getDateTimes: async function () {
      if (this.isLoading) {
        return
      }

      this.isLoading = true;
      const salonId = this.formInfo.salon || this.formInfo.store || '';
      const serviceId = this.formInfo.service || '';
      const specialistId = Boolean(this.selectedSpecialistId && this.selectedSpecialistId !== -1) ? this.selectedSpecialistId : '';

      let search = [serviceId, salonId, specialistId].filter((t) => !!t).join("/");
      if (this.page > 1) {
        const lastDate = [...this.dateTimes].pop();
        const lastDateMoment = this.$moment(lastDate.dateMoment).add(1, 'd').format('DD-MM-YYYY');
        search = [search, `date_start=${ lastDateMoment }`].join('?');
      }

      const response = await this.$api.agent.transport.get(`/appointment/available/${ search }`).then((res) => {
        return res.data
      }).catch((err) => {
        return []
      });
      if (String(specialistId) !== String((this.selectedSpecialistId === -1) ? '' : this.selectedSpecialistId)) {
        return
      }

      let dateTimes = [];
      Object.keys(response || {}).map((date) => {
        dateTimes.push({
          date,
          dateMoment: (date || '').split('-').reverse().join('-'),
          items: response?.[date] || []
        })
      });
      dateTimes = dateTimes.sort((a, b) => {
        const dateA = new Date(a?.dateMoment);
        const dateB = new Date(b?.dateMoment);
        if (dateA > dateB) {
          return 1
        }
        if (dateA < dateB) {
          return -1
        }
        return 0
      });

      if (this.page <= 1 && dateTimes.length <= 0) {
        this.$emit('changeShowForm', false);
        return
      }

      this.dateTimes = [
        ...this.dateTimes,
        ...dateTimes
      ];

      this.isAvaibleNext = Boolean(dateTimes.length > 0);
      this.isLoading = false;

      if (dateTimes.length <= 0) {
        setTimeout(() => {
          document.querySelector('.date-and-time-api__button-pagination.--next').classList.add('swiper-button-disabled');
        }, 100)
      }
    },
    prevDateSwiper: async function () {},
    nextDateSwiper: async function () {
      const swiper = this.$refs?.refSwiperDate?.swiper || null;
      const snapIndex = (swiper?.snapIndex || 0) + 1;
      const realIndex = (swiper?.realIndex || 0) + 1;

      if (this.isDisabledDateNext || (realIndex + 3) < this.dateTimes.length) {
        return
      }

      this.page = this.page + 1;
      await this.getDateTimes();
      // swiper.slideNext();
    },

    changeSelectedDate: function (date) {
      this.selectedDate = date;
    },
    changeSelectedTime: function (time) {
      const selectedDay = this.dateTimes.find((t) => Boolean(t.date === this.selectedDate)).dateMoment;
      const startTime = (time?.begin || '').split(':').splice(0,2).join(':');
      const endTime = (time?.end || '').split(':').splice(0,2).join(':');

      const value = {
        data: selectedDay,
        day: selectedDay,
        start: time?.begin,
        end: time?.end,
        value: [selectedDay, startTime, endTime].join('-'),
      };

      this.$emit('setApointmentTime', value);
    },

  },

}
